import React from "react";
import "./account-verification.css";
import { Link } from "react-router-dom";

const AccountVerification = () => {
 const currentRoute = window.location.pathname;

 return (
  <>
   <div className="container">
    <div className="row">
     <div className="col-md-7 mx-auto av-wrap-vh-center">
      <div className="av-wrap ">
       <div>
        <img className="img-review" src="images/review-img.png" alt="Review" />
       </div>
       {currentRoute !== "/account_verification" && (
        <div className="av-wrap-text mt-3">
         Thank you for registering on the GNA OTC Platform.
        </div>
       )}
       <div className="av-wrap-text">
        Access to the Dashboard and Listing function is <br />
        restricted temporarily as account verification is in
        <br /> progress. Review status in 24-48 hours.{" "}
       </div>
       <div className="av-wrap-text">
        For any urgent requests, please write to
        <br /> admin@gna.energy.
       </div>
       {/* <button className='btn btn-signup btn btn-primary py-2'>Contact Us</button> */}
       <Link to={"/"}>
        <button className="btn btn-signup btn btn-primary py-2 mt-3">
         Home Page
        </button>
       </Link>
      </div>
     </div>
    </div>
   </div>
  </>
 );
};

export default AccountVerification;
